import EmendasParlamentares from '@/views/public/emendas_parlamentares'
import EmendasPorArea from '@/views/public/emendas_parlamentares/EmendasPorArea'
import EmendasPorVereador from '@/views/public/emendas_parlamentares/EmendasPorVereador'
import DetalhesPorArea from '@/views/public/emendas_parlamentares/DetalhesPorArea'
import DetalhesPorVereador from '@/views/public/emendas_parlamentares/DetalhesPorVereador'
import DetalhesPorAno from '@/views/public/emendas_parlamentares/DetalhesPorAno'
import { DEFAULT_TITLE } from '../const'

export const emendasParlamentares = [
  {
    path: '/emendas_parlamentares',
    name: 'emendas_parlamentares',
    component: EmendasParlamentares,
    meta: {
      title: `${DEFAULT_TITLE} | Emendas Parlamentares`
    }
  },
  {
    path: '/emendas_parlamentares/emendas-por-area',
    name: 'emendas_por_area',
    component: EmendasPorArea,
    meta: {
      title: `${DEFAULT_TITLE} | Emendas por Área`
    }
  },
  {
    path: '/emendas_parlamentares/emendas-por-vereador',
    name: 'emendas_por_vereador',
    component: EmendasPorVereador,
    meta: {
      title: `${DEFAULT_TITLE} | Emendas por Vereador`
    }
  },
  {
    path: '/emendas_parlamentares/detalhe-por-area/:secretaria',
    name: 'emendas_detalhe_por_area',
    component: DetalhesPorArea,
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes por Área`
    }
  },
  {
    path: '/emendas_parlamentares/detalhe-por-vereador/:vereador',
    name: 'emendas_detalhe_por_vereador',
    component: DetalhesPorVereador,
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes por Vereador`
    }
  },
  {
    path: '/emendas_parlamentares/detalhes-por-ano',
    name: 'emendas_detalhe_por_ano',
    component: DetalhesPorAno,
    meta: {
      title: `${DEFAULT_TITLE} | Detalhes por Ano`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/emendasParlamentares.js